export enum SystemRole {
  Contributor = 'Contributor',
  ProjectAdmin = 'ProjectAdmin',
  GlobalPublisher = 'GlobalPublisher',
  GlobalProjectAdmin = 'GlobalProjectAdmin',
}

export const SystemRoleMetadata: {
  [key in SystemRole]: { displayName: string; description: string; scope: 'Global' | 'Project' };
} = {
  [SystemRole.Contributor]: {
    displayName: 'Contributor',
    description: 'Can add comments to projects',
    scope: 'Project',
  },
  [SystemRole.ProjectAdmin]: {
    displayName: 'Project Admin',
    description: 'Can manage projects and invite users from same client',
    scope: 'Project',
  },
  [SystemRole.GlobalPublisher]: {
    displayName: 'Global Publisher',
    description: 'Can view all clients and publish content globally',
    scope: 'Global',
  },
  [SystemRole.GlobalProjectAdmin]: {
    displayName: 'Global Project Admin',
    description: 'Can create and manage projects across all clients',
    scope: 'Global',
  },
};
